import React, { useId } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { DEALER_PROPS } from 'client/constants/dealer-reviews';
import { getPlural } from 'client/utils/plural';
import { Button } from 'reactstrap';
import Collapse from 'reactstrap/lib/Collapse';
import { BaseReviewsList } from 'site-modules/dealerships/components/dealer-reviews-section/components/base-reviews-list/base-reviews-list';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';

export function CollapsibleReviewsList({
  reviews,
  params,
  reviewsType,
  initialCount,
  totalReviews,
  isMobile,
  listType,
  newOldReviewsCount,
  onMaxAmountExpanded,
}) {
  const [isCollapsed, toggleIsCollapsed] = useToggle(true);
  const id = useId();

  return (
    <div className="mt-2">
      <div className="text-center">
        <Button
          color="link"
          className="size-16 text-cool-gray-40 fw-normal text-transform-none text-underline border-0 p-0"
          onClick={toggleIsCollapsed}
          data-tracking-id="ddp_view_dealer_reviews"
          data-tracking-value={`${isCollapsed ? 'hide' : 'show'} older reviews`}
          aria-expanded={!isCollapsed}
          aria-controls={id}
        >
          {`${isCollapsed ? 'Show' : 'Hide'} ${totalReviews} older ${getPlural('review', totalReviews)}`}
          <i
            className={classnames('small ps-0_25', { 'icon-arrow-up3': !isCollapsed, 'icon-arrow-down3': isCollapsed })}
            aria-hidden
          />
        </Button>
      </div>

      <Collapse id={id} isOpen={!isCollapsed}>
        <BaseReviewsList
          listType={listType}
          reviews={reviews}
          params={params}
          reviewsType={reviewsType}
          initialCount={initialCount}
          totalReviews={totalReviews}
          newOldReviewsCount={newOldReviewsCount}
          onMaxAmountExpanded={onMaxAmountExpanded}
          onCloseReviewsList={toggleIsCollapsed}
          isMobile={isMobile}
        />
      </Collapse>
    </div>
  );
}

CollapsibleReviewsList.propTypes = {
  listType: PropTypes.string.isRequired,
  reviews: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  params: DEALER_PROPS.isRequired,
  reviewsType: PropTypes.string.isRequired,
  initialCount: PropTypes.number.isRequired,
  totalReviews: PropTypes.number.isRequired,
  newOldReviewsCount: PropTypes.number.isRequired,
  onMaxAmountExpanded: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};
